const isInsideContainer = (target, container) => {
  while (target !== document.body) {
    if (target === container) return true;
    target = target.parentNode;
  }
  return false;
};
export default isInsideContainer;
